import { Component } from '@angular/core';

@Component({
	selector: 'flexus-builders-two',
	template: ` Hello Builders Two <button [routerLink]="['/']">Go To One</button> `
})
export class BuildersTwoComponent {}
